import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import BodyTypesTableContainer from '../../../modules/bodyTypes/components/BodyTypesTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import { hasPermission } from '../../../utils/HelperFunctions';

const BodyTypes = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, searchEle, paginationEle } = useModuleTableHelpers({
    route: 'admin/body-types',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.body_types'),
    withPagination: true,
    queryKey: 'body-types'
  });

  const tableHeaders = [
    { label: t('icon'), customClass: 'logo' },
    { label: t('name_en') },
    { label: t('name_ar') },
    hasPermission(['body_types.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="bodyTypes-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">{searchEle}</div>
        {hasPermission(['body_types.edit']) && <Button text={t('create_body_type')} link="/body-types/create-body-type" />}
      </ListHeader>
      <BodyTypesTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_body_types_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default BodyTypes;
